import React, { useState, useEffect, useRef } from "react";
import BundledEditor from "../widgets/BundledEditor";
import { Button } from "react-bootstrap";

const TextEditorWidget = ({ initialValue }) => {
  const editorRef = useRef(null);

  const [value, setValue] = useState(initialValue);
  const [dirty, setDirty] = useState(false);
  useEffect(() => setDirty(false), [initialValue]);
  const save = () => {
    // if (editorRef.current) {
    //   const content = editorRef.current.getContent();
    //   setDirty(false);
    //   editorRef.current.setDirty(false);
    //   // an application would save the editor content to the server here
    //   console.log(content);
    // }
  };
  return (
    <>
      <BundledEditor
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={value}
        menubar={true}
        init={{
          height: 500,
          menubar: false,
          plugins: [
            "advlist",
            "anchor",
            "autolink",
            "help",
            "image",
            "link",
            "lists",
            "searchreplace",
            "table",
            "wordcount",
            "fullscreen",
            "quickbars",
            "preview",
            "autoresize",
            "code",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic forecolor | alignleft aligncenter" +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help | fullscreen | code",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
      <Button variant="primary" onClick={save} disabled={!dirty}>
        Save
      </Button>
      {dirty && <p>You have unsaved content!</p>}
    </>
  );
};

export default TextEditorWidget;
